var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    fill: "#fbfbfb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4543_00000156561776769795081210000008584309095994129080_",
    transform: "translate(-13935 -984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6864_00000018929140721829161270000002019101969291326904_",
    d: "M13950.4,987.7c-0.4-0.4-0.9-0.4-1.3,0 c0,0,0,0,0,0l-4.5,4.5l-4.5-4.5c-0.3-0.4-0.9-0.4-1.3-0.1c-0.4,0.3-0.4,0.9-0.1,1.3c0,0,0,0,0.1,0.1l4.5,4.5l-4.5,4.5 c-0.3,0.4-0.3,1,0,1.3c0.4,0.3,0.9,0.3,1.3,0l4.5-4.5l4.5,4.5c0.4,0.3,1,0.3,1.3-0.1c0.3-0.4,0.3-0.9,0-1.3l-4.5-4.5l4.5-4.5 C13950.7,988.6,13950.7,988,13950.4,987.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.f9dc5a371da365eabfba25f9d422c352.svg";
export { ForwardRef as ReactComponent };